"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.BreadCrumbsGroup = void 0;
var _material = require("@mui/material");
var _lodash = _interopRequireDefault(require("lodash"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _react = _interopRequireDefault(require("react"));
var _reactRedux = require("react-redux");
var _Breadcrumb = _interopRequireDefault(require("./Breadcrumb"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
const BreadCrumbsGroup = _ref => {
  let {
    crumbs
  } = _ref;
  if (_lodash.default.isEmpty(crumbs)) {
    return /*#__PURE__*/_react.default.createElement(_material.Box, {
      sx: {
        height: 0
      }
    });
  }
  return /*#__PURE__*/_react.default.createElement(_material.Breadcrumbs, {
    "aria-label": "breadcrumb"
  }, _lodash.default.map(crumbs, _ref2 => {
    let {
      key,
      label,
      ...crumbProps
    } = _ref2;
    return /*#__PURE__*/_react.default.createElement(_Breadcrumb.default, _extends({
      key: key || label
    }, crumbProps), label);
  }));
};
exports.BreadCrumbsGroup = BreadCrumbsGroup;
BreadCrumbsGroup.defaultProps = {};
BreadCrumbsGroup.propTypes = {
  crumbs: _propTypes.default.array
};
const Breadcrumbs = () => {
  const crumbs = (0, _reactRedux.useSelector)(state => state.breadcrumbs.crumbs);
  return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement(_material.Grow, {
    in: !_lodash.default.isEmpty(crumbs),
    mountOnEnter: true,
    unmountOnExit: true
  }, /*#__PURE__*/_react.default.createElement(_material.Box, {
    sx: {
      clear: 'both',
      mt: '1rem'
    }
  }, /*#__PURE__*/_react.default.createElement(BreadCrumbsGroup, {
    crumbs: crumbs
  }))));
};
Breadcrumbs.defaultProps = {};
var _default = exports.default = Breadcrumbs;